module.exports = __webpack_public_path__ + "static/img/logo-icon-color.584e774b.svg";